import { render, staticRenderFns } from "./CardTarjaEnqueteRedacaoSportvQRCODE.vue?vue&type=template&id=2a2acfd4&scoped=true"
import script from "./CardTarjaEnqueteRedacaoSportvQRCODE.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteRedacaoSportvQRCODE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteRedacaoSportvQRCODE.vue?vue&type=style&index=0&id=2a2acfd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2acfd4",
  null
  
)

export default component.exports